import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button';
import RestAPI from '../../../Common/restApi';
import withStyles from 'housecall-ui/dist/DesignSystem/Styles/withStyles';
import {
  getSiteIsLiveState,
  getDomainIsActiveState,
  getRedirectionURL,
} from '../../../../Resources/WebsiteConfiguration/WebsiteConfigurationData';

const styles = {
  buttonStyles: {
    color: '#ffffff',
    width: '100%',
  },
};

@withStyles(styles)
@connect((state) => ({
  siteIsLive: getSiteIsLiveState(state),
  domainIsActive: getDomainIsActiveState(state),
  redirectionURL: getRedirectionURL(state),
}))
export default class WebsiteBuilderButton extends PureComponent {
  constructor(props) {
    super(props);
  }

  handleButtonClick() {
    const { siteIsLive, domainIsActive, redirectionURL } = this.props;
    if (!siteIsLive && !domainIsActive) {
      RestAPI.postWithFormData('/pro/apps/notify_cowbell', {});
    }
    window.location.href = redirectionURL;
  }

  getButtonText() {
    const { siteIsLive, domainIsActive } = this.props;
    return siteIsLive || domainIsActive ? 'Edit Website' : 'Launch';
  }

  render() {
    const { classes, siteIsLive, domainIsActive } = this.props;
    if(!(siteIsLive || domainIsActive)) return null;
    return (
      <Button
        variant="contained"
        color="primary"
        className={classes.buttonStyles}
        onClick={() => this.handleButtonClick()}
      >
        {this.getButtonText()}
      </Button>
    );
  }
}
